import {
  Activity,
  ArrowLeftRight,
  BookOpen,
  Bot,
  Briefcase,
  Brain,
  Building2,
  Circle,
  ClipboardList,
  Code2,
  Cog,
  Columns3,
  DatabaseZap,
  Eye,
  FileText,
  FlaskConical,
  Gavel,
  Key,
  Library,
  LayoutDashboard,
  ListTodo,
  Map,
  Menu,
  MessageSquare,
  PieChart,
  PlusCircle,
  Plug,
  PlugZap,
  Radio,
  Server,
  Settings,
  ShieldAlert,
  Sparkles,
  Store,
  Target,
  ToggleRight,
  TrendingUp,
  Upload,
  Users,
  Workflow,
  type LucideIcon,
} from 'lucide-react';

// ---------------------------------------------------------------------------
// Icon registry — maps string names (from ModuleNavItem.icon) to components.
// Only includes icons used across core + finance manifests. Extend as modules
// add new icons to their nav items.
// ---------------------------------------------------------------------------

export const ICON_MAP: Record<string, LucideIcon> = {
  Briefcase,
  Code2,
  FileText,
  ListTodo,
  Activity,
  ArrowLeftRight,
  BookOpen,
  Bot,
  Brain,
  Building2,
  Circle,
  ClipboardList,
  Cog,
  Columns3,
  DatabaseZap,
  Eye,
  FlaskConical,
  Gavel,
  Key,
  Library,
  LayoutDashboard,
  Map,
  Menu,
  MessageSquare,
  PieChart,
  PlusCircle,
  Plug,
  PlugZap,
  Radio,
  Server,
  Settings,
  ShieldAlert,
  Sparkles,
  Store,
  Target,
  ToggleRight,
  TrendingUp,
  Upload,
  Users,
  Workflow,
};

export function resolveIcon(name: string | undefined): LucideIcon {
  if (!name) return Circle;
  return ICON_MAP[name] ?? Circle;
}
